import type { UtilizationBucket } from '@domain/graphql.types';

export type HistogramBucket = {
  endDate: string;
  percentageUtilization?: number;
  price?: number;
  minPrice?: number;
  maxPrice?: number;
  /** median and middle 50% of the station prices of the week (Area Summary only) */
  medianPrice?: number;
  p25Price?: number;
  p75Price?: number;
};

export function ToHistogramBuckets(buckets: UtilizationBucket[] | null | undefined): HistogramBucket[] {
  return (buckets ?? []).map((b) => ({
    endDate: b.endDate,
    percentageUtilization: b.percentageUtilization ?? undefined,
    price: b.price ?? undefined,
  }));
}

export type MonthSegment = { key: string; label: string; count: number };

/** Consecutive weekly buckets grouped by month, for the month axis under the weekly charts. */
export function getMonthSegments(endDates: readonly string[], locale = 'en-US'): MonthSegment[] {
  const segments: MonthSegment[] = [];
  for (const endDate of endDates) {
    const dt = new Date(endDate);
    const key = `${dt.getFullYear()}-${String(dt.getMonth() + 1).padStart(2, '0')}`;
    const last = segments[segments.length - 1];
    if (last?.key === key) {
      last.count += 1;
    } else {
      segments.push({ key, label: dt.toLocaleString(locale, { month: 'short' }), count: 1 });
    }
  }
  return segments;
}
